import { cn } from "../lib/cn";

export interface SpinnerProps {
  size?: number;
  borderColor?: string;
  color?: string;
  className?: string;
}

export function Spinner({
  size = 20,
  borderColor = "var(--color-gold-dim)",
  color = "var(--color-gold)",
  className,
}: SpinnerProps) {
  return (
    <div
      role="status"
      className={cn("inline-block rounded-full", className)}
      style={{
        width: size,
        height: size,
        border: `2px solid ${borderColor}`,
        borderTopColor: color,
        animation: "spin 0.8s linear infinite",
      }}
    >
      <span className="sr-only">Loading</span>
    </div>
  );
}
